// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"styles_thumbnail__XUR2X","title":"styles_title__1HZhU","videoModal":"styles_videoModal__2f6jN","playButton":"styles_playButton__2xo_0"};